/**
 * 全局接口 code 状态码定义
 */
export const CODE = {
    /** 成功 */
    OK: 0,

    /** 设计师端-未登录 */
    UNAUTHORIZED: [1000, 1001, 1002],

    /** 用户端-未登录 */
    UNAUTHORIZED_USER: [401],

    /** 供稿中心 */
    MATERIAlS_CENTER: 9070010,
};
